import { PageHeader } from "shared/page-header/PageHeader";
import { Box, 
  Heading, 
  Text, 
  useColorModeValue,
  Accordion,
  Grid,
  useBreakpointValue
} from "@chakra-ui/react";
import ServiceAccordionItems from "./ServiceAccordionItems";
import { IconType } from "react-icons";
import ServiceCardDescriptor from "./ServiceCardDescriptor";
import ArrowBox from "../../shared/arrow-box/ArrowBox";


interface ServiceDescriptorProps {
    label: string;
    title: string;
    services: { title: string; icon: IconType; items: string[]; }[];
    footer: string; 
    onPrev?: () => void;
    onNext?: () => void;
    prevRoute?: string;
    nextRoute?: string;
      

}

export const ServiceDescriptor  = ({label , title, services, footer , onPrev, onNext , prevRoute, nextRoute } :ServiceDescriptorProps) => { 
    const isMobile = useBreakpointValue({ base: true, md: false });
    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.600");
    const accentColor = useColorModeValue("blue.500", "blue.300");


    return (
      <Box>
      <PageHeader label= {label} />
      <Box maxW="7xl" mx="auto" px={{ base: 4, md: 8 }} py={12}>
      <ArrowBox onPrev={onPrev} onNext={onNext} prevRoute={prevRoute} nextRoute={nextRoute}>
        <Heading 
          as="h2" 
          size="xl" 
          textAlign="center" 
          mb={8}
          bgGradient="linear(to-r, blue.400, purple.600)"
          fontFamily="arial"
          bgClip="text">
          {title}
        </Heading>
        </ArrowBox>
        

        {isMobile ? (
          <Accordion allowToggle>
            <ServiceAccordionItems accentColor={accentColor} services={services}  />
          </Accordion>
        ) : (
          <Grid 
            templateColumns={{ md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} 
            gap={6}
          >

      {services.map((service, index) => (
            <ServiceCardDescriptor 
              icon={service.icon}
              title={service.title}
              colorScheme={accentColor}
              items={service.items}
              bg={cardBg}
              borderColor={borderColor}
            /> ))}
          </Grid>
        )}

        <Text 
          mt={10} 
          textAlign="center" 
          fontSize="lg" 
          color={useColorModeValue("gray.600", "gray.400")}
          fontStyle="italic"
        >
          {footer}
        </Text>
      </Box>
    </Box>
    )
}

export default ServiceDescriptor;

